module.exports = __webpack_public_path__ + "static/media/logo.428916c6.PNG";